import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('LAB_RESEARCH_REVIEW_ORDER')